/*

Class : Payments
Description : Onboarding du compte de paiement (Stripe Connect Express) du camping
et affichage de son statut. Composant autonome (Tailwind), rendu dans ConfigWebapp
(Paramètres généraux).
Author : Franck David

*/




import React, { Component } from 'react'
import Loader from '../UI/Loader'

class Payments extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			status: null,
			connecting: false,
			error: null,
			paying_out: false,
			payout_error: null,
			payout_success: null,
			editing_amount: false,
			payout_amount: ''
		}
	}

	componentDidMount() {
		this.props.fetchStripeStatus()
		.then(status => this.setState({ loading: false, status: status }))
		.catch(() => this.setState({ loading: false, status: null, error: "Impossible de récupérer le statut du compte de paiement." }))
	}

	connect = () => {
		if (this.state.connecting === true)
			return
		this.setState({ connecting: true, error: null })
		this.props.startStripeOnboarding()
		.then(ret => {
			if (ret && ret.url)
			{
				window.location.href = ret.url
				return
			}
			let message = "Une erreur est survenue. Veuillez réessayer."
			if (ret && ret.error === 'stripe_not_configured')
				message = "Le paiement en ligne n'est pas encore configuré sur le serveur (clés Stripe manquantes). Contactez l'administrateur PocketCamp."
			else if (ret && ret.message)
				message = ret.message
			this.setState({ connecting: false, error: message })
		})
		.catch(() => this.setState({ connecting: false, error: "Une erreur est survenue. Veuillez réessayer." }))
	}

	_availableBalanceCents = () => {
		return (this.state.status && this.state.status.available_balance_cents) ? this.state.status.available_balance_cents : 0
	}

	startPayout = () => {
		const available = this._availableBalanceCents()
		this.setState({
			editing_amount: true,
			payout_amount: (available / 100).toFixed(2),
			payout_error: null,
			payout_success: null
		})
	}

	cancelPayout = () => {
		this.setState({ editing_amount: false, payout_amount: '' })
	}

	changePayoutAmount = (event) => {
		this.setState({ payout_amount: event.target.value })
	}

	confirmPayout = () => {
		if (this.state.paying_out === true)
			return
		const available = this._availableBalanceCents()
		const amount_cents = Math.round(parseFloat(this.state.payout_amount) * 100)
		if (isNaN(amount_cents) || amount_cents < 10000 || amount_cents > available)
			return
		this.setState({ paying_out: true, payout_error: null, payout_success: null })
		this.props.triggerStripePayout(amount_cents)
		.then(ret => {
			if (ret && ret.success === true)
			{
				this.props.fetchStripeStatus()
				.then(status => this.setState({ paying_out: false, editing_amount: false, payout_success: "Virement déclenché avec succès.", status: status }))
				.catch(() => this.setState({ paying_out: false, editing_amount: false, payout_success: "Virement déclenché avec succès." }))
				return
			}
			let message = "Une erreur est survenue. Veuillez réessayer."
			if (ret && ret.error === 'balance_below_minimum')
				message = "Le solde disponible est inférieur à 100 €."
			else if (ret && ret.error === 'invalid_amount')
				message = "Le montant saisi n'est pas valide."
			else if (ret && ret.error === 'payouts_disabled')
				message = "Les virements ne sont pas encore activés sur votre compte."
			this.setState({ paying_out: false, payout_error: message })
		})
		.catch(() => this.setState({ paying_out: false, payout_error: "Une erreur est survenue. Veuillez réessayer." }))
	}

	render() {
		const status = this.state.status
		const connected = (status && status.connected === true)
		const active = (connected && status.charges_enabled === true)
		const available_balance_cents = (status && status.available_balance_cents) ? status.available_balance_cents : 0
		const payout_disabled = (this.state.paying_out === true) || (status && status.payouts_enabled !== true) || (available_balance_cents < 10000)
		const payout_amount_cents = Math.round(parseFloat(this.state.payout_amount) * 100)
		const payout_amount_valid = !isNaN(payout_amount_cents) && payout_amount_cents >= 10000 && payout_amount_cents <= available_balance_cents
		const payout_button_class = "font-semibold py-2 px-5 rounded-full text-sm " + (payout_disabled ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700 text-white")
		const confirm_button_class = "font-semibold py-2 px-5 rounded-full text-sm " + ((!payout_amount_valid || this.state.paying_out) ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700 text-white")
		let badge = null
		if (active)
			badge = <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700">Actif</span>
		else if (connected)
			badge = <span className="px-3 py-1 rounded-full text-xs font-semibold bg-amber-100 text-amber-700">En attente de validation</span>
		else
			badge = <span className="px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-500">Non connecté</span>
		return (
			<div className="rounded-2xl border border-gray-100 bg-white shadow-sm p-6">
				<div className="flex items-center justify-between mb-2">
					<h2 className="text-lg font-bold text-gray-800">Paiement en ligne</h2>
					{this.state.loading ? null : badge}
				</div>
				<p className="text-sm text-gray-500 mb-4">
					Encaissez les commandes de vos services directement par carte bancaire.
					Commission PocketCamp : 3,9 % + 0,40 € par transaction.
				</p>
				{this.state.loading ? (
					<div className="py-4"><Loader /></div>
				) : (
					<div>
						{active ? (
							<div>
								<p className="text-sm font-medium text-green-700 mb-4">
									Votre compte de paiement est actif. Les paiements sont reversés sur votre compte.
								</p>
								<div className="flex items-center justify-between">
									<p className="text-sm text-gray-500">
										Solde disponible : <span className="font-semibold text-gray-800">{(available_balance_cents / 100).toFixed(2)} €</span>
									</p>
									{!this.state.editing_amount ? (
										<button
											type="button"
											onClick={this.startPayout}
											disabled={payout_disabled}
											className={payout_button_class}
										>
											Déclencher un virement
										</button>
									) : null}
								</div>
								{available_balance_cents < 10000 ? (
									<p className="mt-2 text-sm font-medium text-amber-600">Virement disponible à partir de 100 € de solde.</p>
								) : null}
								{this.state.editing_amount ? (
									<div className="mt-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
										<label className="block text-sm text-gray-600 mb-2">Montant à virer (minimum 100 €)</label>
										<div className="flex items-center gap-3">
											<input
												type="number"
												min="100"
												max={(available_balance_cents / 100).toFixed(2)}
												step="0.01"
												value={this.state.payout_amount}
												onChange={this.changePayoutAmount}
												disabled={this.state.paying_out}
												className="w-32 rounded-lg border border-gray-300 px-3 py-2 text-sm"
											/>
											<button
												type="button"
												onClick={this.confirmPayout}
												disabled={!payout_amount_valid || this.state.paying_out}
												className={confirm_button_class}
											>
												{this.state.paying_out ? 'Virement en cours…' : 'Confirmer'}
											</button>
											<button
												type="button"
												onClick={this.cancelPayout}
												disabled={this.state.paying_out}
												className="text-sm text-gray-500 hover:text-gray-700"
											>
												Annuler
											</button>
										</div>
										{!payout_amount_valid ? (
											<p className="mt-2 text-xs text-red-500">Le montant doit être compris entre 100 € et {(available_balance_cents / 100).toFixed(2)} €.</p>
										) : null}
									</div>
								) : null}
								{this.state.payout_error ? (
									<p className="mt-3 text-sm font-medium text-red-600">{this.state.payout_error}</p>
								) : null}
								{this.state.payout_success ? (
									<p className="mt-3 text-sm font-medium text-green-700">{this.state.payout_success}</p>
								) : null}
							</div>
						) : (
							<button
								type="button"
								onClick={this.connect}
								disabled={this.state.connecting}
								className="font-semibold py-3 px-6 rounded-full text-white text-sm bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60"
							>
								{this.state.connecting ? 'Redirection…' : (connected ? 'Compléter mon inscription' : 'Connecter mon compte de paiement')}
							</button>
						)}
						{this.state.error ? (
							<p className="mt-3 text-sm font-medium text-red-600">{this.state.error}</p>
						) : null}
					</div>
				)}
			</div>
		)
	}
}

export default Payments
